import React, { useState, useEffect, useMemo } from 'react';
import { motion } from 'framer-motion';

import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import CtaNomal from "../components/CtaNomal";

import "../styles/common.css";
import "../styles/top.css";

import imgWebsite from "../img/common/illustration_service_website.svg";
import imgMarketing from "../img/common/illustration_service_marketing.svg";
import imgBranding from "../img/common/illustration_service_branding.svg";
import imgReason01 from "../img/top/img_top_01.png";
import imgReason02 from "../img/top/img_top_02.png";
import imgReason03 from "../img/top/img_top_03.png";
import fvBack01 from "../img/top/fv-back__left01.svg";
import fvBack02 from "../img/top/fv-back__left02.svg";
import fvBack03 from "../img/top/fv-back__right01.svg";

import { works, resolveWork } from "../data/works";
import { tagLabels } from "../data/tagLabels";

const lang = "ja";

const buildDisplayTags = (w) => {
  const industry = (w.industryTags ?? []).slice(0, 2);
  const companyCountry = w.company?.country ? [`companyCountry:${w.company.country}`] : [];
  return [...industry, ...companyCountry];
};

const TypingText = ({ text, className, variants }) => (
  <motion.span className={`typing-text ${className ?? ""}`} variants={variants}>
    {Array.from(text).map((char, index) => (
      <motion.span className="typing-text__char" variants={typingChar} key={`${char}-${index}`}>
        {char === " " ? "\u00A0" : char}
      </motion.span>
    ))}
  </motion.span>
);

const typingChar = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { duration: 0.01 },
  },
};


const Top = () => {
  const resolvedWorks = works.map(resolveWork);
  const topWorks = resolvedWorks.slice(0, 12);
  const fadeInSlideUp = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: 'easeOut' } },
  };
  const fadeInContainer = {
    hidden: {},
    visible: { transition: { staggerChildren: 0.2 }, },
  };
  const typingContainer = {
    hidden: {},
    visible: { transition: { staggerChildren: 0.055 } },
  };

  const [hasAnimated, setHasAnimated] = useState(false);
  useEffect(() => {
    if (sessionStorage.getItem("hasAnimated")) {
      setHasAnimated(true);
    }
  }, []);
  const handleAnimationComplete = () => {
    sessionStorage.setItem("hasAnimated", "true");
    setHasAnimated(true);
  };

  const slideFromRight = {
    hidden: { opacity: 0, x: 50 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: 'easeOut', delay: 0.2 } },
  };
  const slideFromLeft = {
    hidden: { opacity: 0, x: -50 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: 'easeOut', delay: 0.2 } },
  };


  // アニメーション
  const createFloatVariant = () => {
    const range = 10 + Math.random() * 10;
    const duration = 8 + Math.random() * 6;

    return {
      animate: {
        x: [0, range, -range, 0],
        y: [0, -range, range, 0],
        transition: {
          duration: duration,
          repeat: Infinity,
          repeatType: "loop",
          ease: "easeInOut",
        },
      },
    };
  };

  const variant0 = useMemo(() => createFloatVariant(), []);
  const variant1 = useMemo(() => createFloatVariant(), []);
  const variant2 = useMemo(() => createFloatVariant(), []);
  const variant3 = useMemo(() => createFloatVariant(), []);
  const variant4 = useMemo(() => createFloatVariant(), []);

  return (
    <>
      <Navbar></Navbar>
      <main className='top'>

        <div className='fv-back'>
          <div className='fv-back__item'>
            <div className="floating-object__01">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="auto"
                viewBox="-40 -50 550 600"
                preserveAspectRatio="xMidYMid meet"
              >
                <motion.path variants={variant0} animate="animate" d="M312.744 304.246L311.845 303.429C297.586 290.498 275.544 291.581 262.613 305.84L54.6908 535.109C41.7595 549.368 42.8422 571.411 57.1013 584.342L58.0002 585.159C72.2593 598.09 94.3017 597.008 107.233 582.749L315.155 353.479C328.086 339.22 327.003 317.177 312.744 304.246Z" fill="url(#paint0_linear_674_5743)" />
                <motion.path variants={variant1} animate="animate" d="M11.4436 423.467L12.3424 424.284C26.6016 437.215 48.6439 436.133 61.5752 421.874L116.712 361.078C103.781 375.337 104.863 397.38 119.122 410.311L120.021 411.128C134.28 424.059 156.323 422.977 169.254 408.718L377.176 179.448C390.107 165.189 389.024 143.147 374.765 130.215L373.866 129.398C359.607 116.467 337.565 117.55 324.634 131.809L269.497 192.604C282.428 178.345 281.346 156.303 267.086 143.371L266.188 142.554C251.928 129.623 229.886 130.706 216.955 144.965L9.03287 374.234C-3.8984 388.493 -2.81558 410.536 11.4436 423.467Z" fill="url(#paint1_linear_674_5743)" />
                <motion.path variants={variant2} animate="animate" d="M335.992 11.4437C348.923 -2.8154 370.966 -3.89809 385.225 9.03318L386.124 9.85031C400.383 22.7816 401.465 44.824 388.534 59.0831C375.603 73.3423 353.561 74.425 339.301 61.4937L338.403 60.6766C324.143 47.7453 323.061 25.7029 335.992 11.4437Z" fill="url(#paint2_linear_674_5743)" />
                <defs>
                  <linearGradient id="paint0_linear_674_5743" x1="250.859" y1="369.642" x2="-50.762" y2="710.969" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#66C0A8" />
                    <stop offset="1" stop-color="#CFFFF9" />
                  </linearGradient>
                  <linearGradient id="paint1_linear_674_5743" x1="284.532" y1="198.913" x2="-8.09313" y2="638.777" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#66C0A8" />
                    <stop offset="1" stop-color="#CFFFF9" />
                  </linearGradient>
                  <linearGradient id="paint2_linear_674_5743" x1="378.978" y1="17.7015" x2="308.863" y2="103.204" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#66C0A8" />
                    <stop offset="1" stop-color="#CFFFF9" />
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <div className="floating-object__02">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="-40 0 550 600"
                preserveAspectRatio="xMidYMid meet"
                width="100%"
                height="auto"
              >
                <motion.path variants={variant2} animate="animate" d="M181.984 87.0496L181.358 86.4804C171.643 77.6757 156.633 78.3968 147.809 88.1123L6.15663 244.319C-2.64803 254.035 -1.92696 269.044 7.78853 277.868L8.41472 278.437C18.1302 287.242 33.1399 286.521 41.9635 276.805L183.616 120.598C192.421 110.883 191.7 95.8733 181.984 87.0496Z" fill="url(#paint0_linear_674_5755)" />
                <path d="M49.5534 196.482L191.206 40.2752C200.011 30.5597 199.29 15.55 189.574 6.72639L188.948 6.15711C179.232 -2.64755 164.223 -1.92647 155.399 7.78901L13.7465 163.996C4.94181 173.711 5.66288 188.721 15.3784 197.545L16.0046 198.114C25.7201 206.919 40.7297 206.197 49.5534 196.482Z" fill="url(#paint1_linear_674_5755)" />
                <defs>
                  <linearGradient id="paint0_linear_674_5755" x1="52.401" y1="244.318" x2="204.714" y2="118.918" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#FFD8AB" />
                    <stop offset="1" stop-color="#FBEDBF" />
                  </linearGradient>
                  <linearGradient id="paint1_linear_674_5755" x1="59.9909" y1="163.995" x2="212.304" y2="38.5948" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#FFD8AB" />
                    <stop offset="1" stop-color="#FBEDBF" />
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <div className="floating-object__03">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="-100 -100 400 400"
                preserveAspectRatio="xMidYMid meet"
                width="100%"
                height="auto"
              >
                <motion.path variants={variant1} animate="animate" d="M181.984 87.0496L181.358 86.4804C171.643 77.6757 156.633 78.3968 147.809 88.1123L6.15663 244.319C-2.64803 254.035 -1.92696 269.044 7.78853 277.868L8.41472 278.437C18.1302 287.242 33.1399 286.521 41.9635 276.805L183.616 120.598C192.421 110.883 191.7 95.8733 181.984 87.0496Z" fill="url(#paint0_linear_674_5755)" />
                <motion.path variants={variant0} animate="animate" d="M49.5534 196.482L191.206 40.2752C200.011 30.5597 199.29 15.55 189.574 6.72639L188.948 6.15711C179.232 -2.64755 164.223 -1.92647 155.399 7.78901L13.7465 163.996C4.94181 173.711 5.66288 188.721 15.3784 197.545L16.0046 198.114C25.7201 206.919 40.7297 206.197 49.5534 196.482Z" fill="url(#paint1_linear_674_5755)" />
                <defs>
                  <linearGradient id="paint0_linear_674_5755" x1="52.401" y1="244.318" x2="204.714" y2="118.918" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#FFD8AB" />
                    <stop offset="1" stop-color="#FBEDBF" />
                  </linearGradient>
                  <linearGradient id="paint1_linear_674_5755" x1="59.9909" y1="163.995" x2="212.304" y2="38.5948" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#FFD8AB" />
                    <stop offset="1" stop-color="#FBEDBF" />
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <div className="floating-object__04">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="-100 -100 500 700"
                preserveAspectRatio="xMidYMid meet"
                width="100%"
                height="auto"
              >
                <motion.path variants={variant3} animate="animate" d="M76.7266 254.734L77.5173 255.455C90.031 266.806 109.36 265.852 120.687 253.339L303.042 52.2599C314.392 39.7463 313.439 20.4176 300.925 9.09025L300.134 8.3692C287.621 -2.98145 268.292 -2.0278 256.965 10.4858L74.6099 211.564C63.2592 224.078 64.213 243.407 76.7266 254.734Z" fill="url(#paint0_linear_674_5648)" />
                <motion.path variants={variant0} animate="animate" d="M340.954 150.183L340.164 149.462C327.65 138.111 308.321 139.065 296.994 151.579L248.637 204.913C259.988 192.399 259.035 173.07 246.521 161.743L245.73 161.022C233.216 149.671 213.888 150.625 202.56 163.139L20.2057 364.217C8.85501 376.731 9.80859 396.06 22.3222 407.387L23.1131 408.108C35.6267 419.459 54.9554 418.505 66.2828 405.991L114.639 352.657C103.289 365.171 104.242 384.499 116.756 395.827L117.547 396.548C130.06 407.899 149.389 406.945 160.716 394.431L343.071 193.353C354.422 180.839 353.468 161.51 340.954 150.183Z" fill="url(#paint1_linear_674_5648)" />
                <motion.path variants={variant1} animate="animate" d="M54.5372 511.542C43.1866 524.055 23.8579 524.986 11.3675 513.658L10.5766 512.937C-1.93698 501.587 -2.8673 482.258 8.46009 469.768C19.8107 457.254 39.1394 456.324 51.6298 467.651L52.4205 468.372C64.9342 479.723 65.8646 499.051 54.5372 511.542Z" fill="url(#paint2_linear_674_5648)" />
                <defs>
                  <linearGradient id="paint0_linear_674_5648" x1="103.595" y1="106.027" x2="274.068" y2="157.82" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#FF93A6" />
                    <stop offset="1" stop-color="#FFB683" />
                  </linearGradient>
                  <linearGradient id="paint1_linear_674_5648" x1="63.4595" y1="251.762" x2="285.496" y2="341.359" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#FF93A6" />
                    <stop offset="1" stop-color="#FFB683" />
                  </linearGradient>
                  <linearGradient id="paint2_linear_674_5648" x1="9.89691" y1="484.566" x2="52.5224" y2="498.522" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#FF93A6" />
                    <stop offset="1" stop-color="#FFB683" />
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <div className="floating-object__05">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="-100 -100 500 700"
                preserveAspectRatio="xMidYMid meet"
                width="100%"
                height="auto"
              >
                <motion.path variants={variant3} animate="animate" d="M341.777 44.7983L337.626 49.3832C327.821 60.1948 311.108 61.0157 300.296 51.2109L299.615 50.5913C288.803 40.7865 287.982 24.0734 297.787 13.2618L301.938 8.67692C311.743 -2.13471 328.456 -2.95564 339.268 6.84917L339.949 7.46874C350.761 17.2736 351.582 33.9867 341.777 44.7983Z" fill="url(#paint0_linear_674_5748)" />
                <motion.path variants={variant4} animate="animate" d="M283.149 70.1064L282.468 69.4869C271.656 59.6821 254.943 60.503 245.138 71.3146L204.339 116.311C214.144 105.5 213.323 88.7867 202.511 78.9819L201.83 78.3623C191.018 68.5575 174.305 69.3784 164.5 80.1901L6.84868 254.028C-2.95613 264.84 -2.13519 281.553 8.67644 291.358L9.35797 291.977C20.1696 301.782 36.8827 300.961 46.6875 290.149L154.308 171.469L87.4867 245.153C77.6819 255.964 78.5028 272.677 89.3145 282.482L89.996 283.102C100.808 292.906 117.521 292.086 127.326 281.274L284.977 107.436C294.782 96.6244 293.961 79.9113 283.149 70.1064Z" fill="url(#paint1_linear_674_5748)" />
                <defs>
                  <linearGradient id="paint0_linear_674_5748" x1="306.867" y1="46.6124" x2="350.625" y2="8.08215" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#FFD8AB" />
                    <stop offset="1" stop-color="#FBEDBF" />
                  </linearGradient>
                  <linearGradient id="paint1_linear_674_5748" x1="80.5805" y1="252.257" x2="259.296" y2="56.5711" gradientUnits="userSpaceOnUse">
                    <stop stop-color="#FFD8AB" />
                    <stop offset="1" stop-color="#FBEDBF" />
                  </linearGradient>
                </defs>
              </svg>
            </div>
            <motion.div className="rotating-object__01" animate={{ rotate: [0, 360], scale: [1, 1.2, 1], }}
              transition={{
                duration: 6,
                repeat: Infinity,
                repeatDelay: 2,
                ease: 'easeInOut',
              }}
            >
              <svg
                width="100%"
                height="100%"
                viewBox="0 0 59 59"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M31.5665 6.03326C30.1887 7.41102 27.9517 7.41102 26.5665 6.03326C25.1888 4.6555 25.1888 2.41849 26.5665 1.03332C27.9443 -0.34444 30.1813 -0.34444 31.5665 1.03332C32.9442 2.41108 32.9442 4.64809 31.5665 6.03326Z" fill="#C7CFE4" />
                <path d="M44.3368 18.8041C42.9591 20.1819 40.722 20.1819 39.3369 18.8041C37.9517 17.4263 37.9591 15.1893 39.3369 13.8042C40.7146 12.419 42.9516 12.4264 44.3368 13.8042C45.7146 15.1819 45.7146 17.4189 44.3368 18.8041Z" fill="#C7CFE4" />
                <path d="M57.1063 31.5731C55.7286 32.9509 53.4916 32.9509 52.1064 31.5731C50.7212 30.1954 50.7287 27.9584 52.1064 26.5732C53.4842 25.188 55.7212 25.1954 57.1063 26.5732C58.4915 27.951 58.4841 30.188 57.1063 31.5731Z" fill="#C7CFE4" />
                <path d="M31.5665 6.03326C30.1887 7.41102 27.9517 7.41102 26.5665 6.03326C25.1888 4.6555 25.1888 2.41849 26.5665 1.03332C27.9443 -0.34444 30.1813 -0.34444 31.5665 1.03332C32.9442 2.41108 32.9442 4.64809 31.5665 6.03326Z" fill="#C7CFE4" />
                <path d="M44.3368 18.8041C42.9591 20.1819 40.722 20.1819 39.3369 18.8041C37.9517 17.4263 37.9591 15.1893 39.3369 13.8042C40.7146 12.419 42.9516 12.4264 44.3368 13.8042C45.7146 15.1819 45.7146 17.4189 44.3368 18.8041Z" fill="#C7CFE4" />
                <path d="M57.1063 31.5731C55.7286 32.9509 53.4916 32.9509 52.1064 31.5731C50.7212 30.1954 50.7287 27.9584 52.1064 26.5732C53.4842 25.188 55.7212 25.1954 57.1063 26.5732C58.4915 27.951 58.4841 30.188 57.1063 31.5731Z" fill="#C7CFE4" />
                <path d="M31.5665 31.5731C30.1887 32.9509 27.9517 32.9509 26.5665 31.5731C25.1888 30.1954 25.1888 27.9584 26.5665 26.5732C27.9443 25.188 30.1813 25.1954 31.5665 26.5732C32.9442 27.951 32.9442 30.188 31.5665 31.5731Z" fill="#C7CFE4" />
                <path d="M44.337 44.3433C42.9592 45.7211 40.7222 45.7211 39.337 44.3433C37.9593 42.9656 37.9593 40.7285 39.337 39.3434C40.7148 37.9656 42.9518 37.9656 44.337 39.3434C45.7147 40.7211 45.7147 42.9581 44.337 44.3433Z" fill="#C7CFE4" />
                <path d="M31.5665 31.5731C30.1887 32.9509 27.9517 32.9509 26.5665 31.5731C25.1888 30.1954 25.1888 27.9584 26.5665 26.5732C27.9443 25.188 30.1813 25.1954 31.5665 26.5732C32.9442 27.951 32.9442 30.188 31.5665 31.5731Z" fill="#C7CFE4" />
                <path d="M44.337 44.3433C42.9592 45.7211 40.7222 45.7211 39.337 44.3433C37.9593 42.9656 37.9593 40.7285 39.337 39.3434C40.7148 37.9656 42.9518 37.9656 44.337 39.3434C45.7147 40.7211 45.7147 42.9581 44.337 44.3433Z" fill="#C7CFE4" />
                <path d="M18.7959 44.3433C17.4182 45.7211 15.1812 45.7211 13.796 44.3433C12.4183 42.9656 12.4183 40.7285 13.796 39.3434C15.1738 37.9656 17.4108 37.9656 18.7959 39.3434C20.1811 40.7211 20.1737 42.9581 18.7959 44.3433Z" fill="#C7CFE4" />
                <path d="M31.5665 57.1142C30.1887 58.4919 27.9517 58.4919 26.5665 57.1142C25.1888 55.7364 25.1888 53.4994 26.5665 52.1142C27.9443 50.7291 30.1813 50.7365 31.5665 52.1142C32.9516 53.492 32.9442 55.729 31.5665 57.1142Z" fill="#C7CFE4" />
                <path d="M18.7959 44.3433C17.4182 45.7211 15.1812 45.7211 13.796 44.3433C12.4183 42.9656 12.4183 40.7285 13.796 39.3434C15.1738 37.9656 17.4108 37.9656 18.7959 39.3434C20.1811 40.7211 20.1737 42.9581 18.7959 44.3433Z" fill="#C7CFE4" />
                <path d="M31.5665 57.1142C30.1887 58.4919 27.9517 58.4919 26.5665 57.1142C25.1888 55.7364 25.1888 53.4994 26.5665 52.1142C27.9443 50.7291 30.1813 50.7365 31.5665 52.1142C32.9516 53.492 32.9442 55.729 31.5665 57.1142Z" fill="#C7CFE4" />
                <path d="M13.8038 18.8023C12.4261 17.4245 12.4261 15.1875 13.8038 13.8024C15.1816 12.4246 17.4186 12.4246 18.8038 13.8024C20.1815 15.1801 20.1815 17.4171 18.8038 18.8023C17.426 20.1801 15.189 20.1801 13.8038 18.8023Z" fill="#C7CFE4" />
                <path d="M1.03332 31.5728C-0.34444 30.195 -0.34444 27.958 1.03332 26.5729C2.41108 25.1951 4.64809 25.1951 6.03325 26.5729C7.41101 27.9506 7.41101 30.1876 6.03325 31.5728C4.65549 32.9506 2.41849 32.9506 1.03332 31.5728Z" fill="#C7CFE4" />
              </svg>
            </motion.div>
            <motion.div className="rotating-object__02" animate={{ rotate: [0, 360], scale: [1, 1.2, 1], }}
              transition={{
                duration: 6,
                repeat: Infinity,
                repeatDelay: 1,
                ease: 'easeInOut',
              }}
            >
              <svg
                width="100%"
                height="100%"
                viewBox="0 0 59 59"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M31.5665 6.03326C30.1887 7.41102 27.9517 7.41102 26.5665 6.03326C25.1888 4.6555 25.1888 2.41849 26.5665 1.03332C27.9443 -0.34444 30.1813 -0.34444 31.5665 1.03332C32.9442 2.41108 32.9442 4.64809 31.5665 6.03326Z" fill="#C7CFE4" />
                <path d="M44.3368 18.8041C42.9591 20.1819 40.722 20.1819 39.3369 18.8041C37.9517 17.4263 37.9591 15.1893 39.3369 13.8042C40.7146 12.419 42.9516 12.4264 44.3368 13.8042C45.7146 15.1819 45.7146 17.4189 44.3368 18.8041Z" fill="#C7CFE4" />
                <path d="M57.1063 31.5731C55.7286 32.9509 53.4916 32.9509 52.1064 31.5731C50.7212 30.1954 50.7287 27.9584 52.1064 26.5732C53.4842 25.188 55.7212 25.1954 57.1063 26.5732C58.4915 27.951 58.4841 30.188 57.1063 31.5731Z" fill="#C7CFE4" />
                <path d="M31.5665 6.03326C30.1887 7.41102 27.9517 7.41102 26.5665 6.03326C25.1888 4.6555 25.1888 2.41849 26.5665 1.03332C27.9443 -0.34444 30.1813 -0.34444 31.5665 1.03332C32.9442 2.41108 32.9442 4.64809 31.5665 6.03326Z" fill="#C7CFE4" />
                <path d="M44.3368 18.8041C42.9591 20.1819 40.722 20.1819 39.3369 18.8041C37.9517 17.4263 37.9591 15.1893 39.3369 13.8042C40.7146 12.419 42.9516 12.4264 44.3368 13.8042C45.7146 15.1819 45.7146 17.4189 44.3368 18.8041Z" fill="#C7CFE4" />
                <path d="M57.1063 31.5731C55.7286 32.9509 53.4916 32.9509 52.1064 31.5731C50.7212 30.1954 50.7287 27.9584 52.1064 26.5732C53.4842 25.188 55.7212 25.1954 57.1063 26.5732C58.4915 27.951 58.4841 30.188 57.1063 31.5731Z" fill="#C7CFE4" />
                <path d="M31.5665 31.5731C30.1887 32.9509 27.9517 32.9509 26.5665 31.5731C25.1888 30.1954 25.1888 27.9584 26.5665 26.5732C27.9443 25.188 30.1813 25.1954 31.5665 26.5732C32.9442 27.951 32.9442 30.188 31.5665 31.5731Z" fill="#C7CFE4" />
                <path d="M44.337 44.3433C42.9592 45.7211 40.7222 45.7211 39.337 44.3433C37.9593 42.9656 37.9593 40.7285 39.337 39.3434C40.7148 37.9656 42.9518 37.9656 44.337 39.3434C45.7147 40.7211 45.7147 42.9581 44.337 44.3433Z" fill="#C7CFE4" />
                <path d="M31.5665 31.5731C30.1887 32.9509 27.9517 32.9509 26.5665 31.5731C25.1888 30.1954 25.1888 27.9584 26.5665 26.5732C27.9443 25.188 30.1813 25.1954 31.5665 26.5732C32.9442 27.951 32.9442 30.188 31.5665 31.5731Z" fill="#C7CFE4" />
                <path d="M44.337 44.3433C42.9592 45.7211 40.7222 45.7211 39.337 44.3433C37.9593 42.9656 37.9593 40.7285 39.337 39.3434C40.7148 37.9656 42.9518 37.9656 44.337 39.3434C45.7147 40.7211 45.7147 42.9581 44.337 44.3433Z" fill="#C7CFE4" />
                <path d="M18.7959 44.3433C17.4182 45.7211 15.1812 45.7211 13.796 44.3433C12.4183 42.9656 12.4183 40.7285 13.796 39.3434C15.1738 37.9656 17.4108 37.9656 18.7959 39.3434C20.1811 40.7211 20.1737 42.9581 18.7959 44.3433Z" fill="#C7CFE4" />
                <path d="M31.5665 57.1142C30.1887 58.4919 27.9517 58.4919 26.5665 57.1142C25.1888 55.7364 25.1888 53.4994 26.5665 52.1142C27.9443 50.7291 30.1813 50.7365 31.5665 52.1142C32.9516 53.492 32.9442 55.729 31.5665 57.1142Z" fill="#C7CFE4" />
                <path d="M18.7959 44.3433C17.4182 45.7211 15.1812 45.7211 13.796 44.3433C12.4183 42.9656 12.4183 40.7285 13.796 39.3434C15.1738 37.9656 17.4108 37.9656 18.7959 39.3434C20.1811 40.7211 20.1737 42.9581 18.7959 44.3433Z" fill="#C7CFE4" />
                <path d="M31.5665 57.1142C30.1887 58.4919 27.9517 58.4919 26.5665 57.1142C25.1888 55.7364 25.1888 53.4994 26.5665 52.1142C27.9443 50.7291 30.1813 50.7365 31.5665 52.1142C32.9516 53.492 32.9442 55.729 31.5665 57.1142Z" fill="#C7CFE4" />
                <path d="M13.8038 18.8023C12.4261 17.4245 12.4261 15.1875 13.8038 13.8024C15.1816 12.4246 17.4186 12.4246 18.8038 13.8024C20.1815 15.1801 20.1815 17.4171 18.8038 18.8023C17.426 20.1801 15.189 20.1801 13.8038 18.8023Z" fill="#C7CFE4" />
                <path d="M1.03332 31.5728C-0.34444 30.195 -0.34444 27.958 1.03332 26.5729C2.41108 25.1951 4.64809 25.1951 6.03325 26.5729C7.41101 27.9506 7.41101 30.1876 6.03325 31.5728C4.65549 32.9506 2.41849 32.9506 1.03332 31.5728Z" fill="#C7CFE4" />
              </svg>
            </motion.div>
            <motion.div className="rotating-object__03" animate={{ rotate: [0, 360], scale: [1, 1.2, 1], }}
              transition={{
                duration: 6,
                repeat: Infinity,
                repeatDelay: 3,
                ease: 'easeInOut',
              }}
            >
              <svg
                width="100%"
                height="100%"
                viewBox="0 0 59 59"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M31.5665 6.03326C30.1887 7.41102 27.9517 7.41102 26.5665 6.03326C25.1888 4.6555 25.1888 2.41849 26.5665 1.03332C27.9443 -0.34444 30.1813 -0.34444 31.5665 1.03332C32.9442 2.41108 32.9442 4.64809 31.5665 6.03326Z" fill="#C7CFE4" />
                <path d="M44.3368 18.8041C42.9591 20.1819 40.722 20.1819 39.3369 18.8041C37.9517 17.4263 37.9591 15.1893 39.3369 13.8042C40.7146 12.419 42.9516 12.4264 44.3368 13.8042C45.7146 15.1819 45.7146 17.4189 44.3368 18.8041Z" fill="#C7CFE4" />
                <path d="M57.1063 31.5731C55.7286 32.9509 53.4916 32.9509 52.1064 31.5731C50.7212 30.1954 50.7287 27.9584 52.1064 26.5732C53.4842 25.188 55.7212 25.1954 57.1063 26.5732C58.4915 27.951 58.4841 30.188 57.1063 31.5731Z" fill="#C7CFE4" />
                <path d="M31.5665 6.03326C30.1887 7.41102 27.9517 7.41102 26.5665 6.03326C25.1888 4.6555 25.1888 2.41849 26.5665 1.03332C27.9443 -0.34444 30.1813 -0.34444 31.5665 1.03332C32.9442 2.41108 32.9442 4.64809 31.5665 6.03326Z" fill="#C7CFE4" />
                <path d="M44.3368 18.8041C42.9591 20.1819 40.722 20.1819 39.3369 18.8041C37.9517 17.4263 37.9591 15.1893 39.3369 13.8042C40.7146 12.419 42.9516 12.4264 44.3368 13.8042C45.7146 15.1819 45.7146 17.4189 44.3368 18.8041Z" fill="#C7CFE4" />
                <path d="M57.1063 31.5731C55.7286 32.9509 53.4916 32.9509 52.1064 31.5731C50.7212 30.1954 50.7287 27.9584 52.1064 26.5732C53.4842 25.188 55.7212 25.1954 57.1063 26.5732C58.4915 27.951 58.4841 30.188 57.1063 31.5731Z" fill="#C7CFE4" />
                <path d="M31.5665 31.5731C30.1887 32.9509 27.9517 32.9509 26.5665 31.5731C25.1888 30.1954 25.1888 27.9584 26.5665 26.5732C27.9443 25.188 30.1813 25.1954 31.5665 26.5732C32.9442 27.951 32.9442 30.188 31.5665 31.5731Z" fill="#C7CFE4" />
                <path d="M44.337 44.3433C42.9592 45.7211 40.7222 45.7211 39.337 44.3433C37.9593 42.9656 37.9593 40.7285 39.337 39.3434C40.7148 37.9656 42.9518 37.9656 44.337 39.3434C45.7147 40.7211 45.7147 42.9581 44.337 44.3433Z" fill="#C7CFE4" />
                <path d="M31.5665 31.5731C30.1887 32.9509 27.9517 32.9509 26.5665 31.5731C25.1888 30.1954 25.1888 27.9584 26.5665 26.5732C27.9443 25.188 30.1813 25.1954 31.5665 26.5732C32.9442 27.951 32.9442 30.188 31.5665 31.5731Z" fill="#C7CFE4" />
                <path d="M44.337 44.3433C42.9592 45.7211 40.7222 45.7211 39.337 44.3433C37.9593 42.9656 37.9593 40.7285 39.337 39.3434C40.7148 37.9656 42.9518 37.9656 44.337 39.3434C45.7147 40.7211 45.7147 42.9581 44.337 44.3433Z" fill="#C7CFE4" />
                <path d="M18.7959 44.3433C17.4182 45.7211 15.1812 45.7211 13.796 44.3433C12.4183 42.9656 12.4183 40.7285 13.796 39.3434C15.1738 37.9656 17.4108 37.9656 18.7959 39.3434C20.1811 40.7211 20.1737 42.9581 18.7959 44.3433Z" fill="#C7CFE4" />
                <path d="M31.5665 57.1142C30.1887 58.4919 27.9517 58.4919 26.5665 57.1142C25.1888 55.7364 25.1888 53.4994 26.5665 52.1142C27.9443 50.7291 30.1813 50.7365 31.5665 52.1142C32.9516 53.492 32.9442 55.729 31.5665 57.1142Z" fill="#C7CFE4" />
                <path d="M18.7959 44.3433C17.4182 45.7211 15.1812 45.7211 13.796 44.3433C12.4183 42.9656 12.4183 40.7285 13.796 39.3434C15.1738 37.9656 17.4108 37.9656 18.7959 39.3434C20.1811 40.7211 20.1737 42.9581 18.7959 44.3433Z" fill="#C7CFE4" />
                <path d="M31.5665 57.1142C30.1887 58.4919 27.9517 58.4919 26.5665 57.1142C25.1888 55.7364 25.1888 53.4994 26.5665 52.1142C27.9443 50.7291 30.1813 50.7365 31.5665 52.1142C32.9516 53.492 32.9442 55.729 31.5665 57.1142Z" fill="#C7CFE4" />
                <path d="M13.8038 18.8023C12.4261 17.4245 12.4261 15.1875 13.8038 13.8024C15.1816 12.4246 17.4186 12.4246 18.8038 13.8024C20.1815 15.1801 20.1815 17.4171 18.8038 18.8023C17.426 20.1801 15.189 20.1801 13.8038 18.8023Z" fill="#C7CFE4" />
                <path d="M1.03332 31.5728C-0.34444 30.195 -0.34444 27.958 1.03332 26.5729C2.41108 25.1951 4.64809 25.1951 6.03325 26.5729C7.41101 27.9506 7.41101 30.1876 6.03325 31.5728C4.65549 32.9506 2.41849 32.9506 1.03332 31.5728Z" fill="#C7CFE4" />
              </svg>
            </motion.div>
            <div className='img-object__01'>
              <img src={fvBack01} alt="" />
            </div>
            <div className='img-object__02'>
              <img src={fvBack02} alt="" />
            </div>
            <div className='img-object__03'>
              <img src={fvBack03} alt="" />
            </div>
            <div className='img-object__04'>
              <img src={fvBack02} alt="" />
            </div>
            <div className='img-object__05'>
              <img src={fvBack01} alt="" />
            </div>
          </div>
          <section className='fv'>
            <div className='fv-text'>
              <motion.h1 className="fv-text__headline" initial="hidden" animate="visible" onAnimationComplete={handleAnimationComplete} variants={fadeInContainer}>
                <TypingText text="アナログの温もり" className="fv-text__gradationOrange" variants={typingContainer} />
                <motion.span className='fv-text__smallText' variants={fadeInSlideUp}>
                  と
                </motion.span>
                <br className='sp-only' />
                <TypingText text="デジタルの革新" className="fv-text__gradationBlue" variants={typingContainer} />
                <motion.span className='fv-text__smallText' variants={fadeInSlideUp}>
                  で
                </motion.span>
                <br />
                <TypingText text="世界とつながる企業へ。" variants={typingContainer} />
              </motion.h1>
              <p className='fv-text__lead'>
                ヨーロッパ市場での売上拡大やブランド強化を支援。<br />グローバル展開のノウハウを活かし、Web制作・マーケティング・ブランディング支援を通じて、<br className='pc-only' />企業の成長を加速させるパートナーです。
              </p>
            </div>
            <div className='scroll-box'>
              <div className="scroll-down">
                <div className="scroll-down__text"><span>scroll</span></div>
                <div className="scroll-down__line"></div>
              </div>
            </div>
          </section>
          <div className='content-back'>
            <section className='work'>

              <motion.div className="title" variants={fadeInSlideUp} initial={hasAnimated ? "visible" : "hidden"} whileInView="visible" viewport={{ once: true, amount: 0.2 }} onAnimationComplete={handleAnimationComplete}>
                <p className='title-lead'>WORK</p>
                <h2>制作実績</h2>
              </motion.div>
              <div className="work-box">
                {topWorks.map((w) => {
                  const displayTags = buildDisplayTags(w);

                  return (
                    <article key={w.slug}>
                      <a href={`/work/${w.slug}`}>
                        <div className="work-box__image">
                          <img src={w.thumbnail} alt={w.title?.[lang] ?? ""} />
                        </div>
                        <div className="work-box__text">
                          <h3>{w.title?.[lang]}</h3>

                          {displayTags.length > 0 && (
                            <ul className="work-box__tag">
                              {displayTags.map((tag) => (
                                <li key={tag}>{tagLabels[tag]?.[lang] ?? tag}</li>
                              ))}
                            </ul>
                          )}
                        </div>
                      </a>
                    </article>
                  );
                })}
              </div>

              <div className='button-content button-arrow button-black'>
                <a href="/work">一覧をみる</a>
              </div>
            </section>
            <section className='service' id="service">
              <motion.div className="title" variants={fadeInSlideUp} initial={hasAnimated ? "visible" : "hidden"} whileInView="visible" viewport={{ once: true, amount: 0.2 }} onAnimationComplete={handleAnimationComplete}>
                <p className='title-lead'>SERVICE</p>
                <h2>事業内容</h2>
              </motion.div>
              <div className='service-text'>
                <h3>ヨーロッパ市場での成功に向けて、企業の強みを活かした戦略設計から運用・成果創出までをトータルサポート。</h3>
                <p>企業の価値を最大化する「ブランディング支援」から、戦略的な「Webサイト制作」、さらにグローバル市場での成果を生む「マーケティング支援」まで、ヨーロッパ市場での成長を支える包括的なサポートを提供します。</p>
              </div>
              <motion.div className="service-box flexBox-bkWhite" variants={fadeInContainer} initial={hasAnimated ? "visible" : "hidden"} whileInView="visible" viewport={{ once: true, amount: 0.2 }} onAnimationComplete={handleAnimationComplete}>
                <motion.div className="service-box__item" variants={fadeInSlideUp}>
                  <div className='service-item__text'>
                    <div className='service-item__cercle gradation-green'></div>
                    <p className='service-item__number'>SERVICE01</p>
                    <h3>Webサイト制作</h3>
                    <p className='service-item__detail'>企業のブランド価値を最大化する、戦略的かつ洗練されたWebサイトを構築。多言語対応・SEO対策・越境EC支援など、ヨーロッパ市場で成果を生む設計を提供。デザイン性と機能性を兼ね備えたWebサイトで、ビジネスの成長をサポートします。</p>
                  </div>
                  <div className='service-item__image'>
                    <img src={imgWebsite} alt="" />
                  </div>
                  <div className='button-content button-arrow button-black'>
                    <a href="/website">詳しくみる</a>
                  </div>
                </motion.div>
                <motion.div className="service-box__item" variants={fadeInSlideUp}>
                  <div className='service-item__text'>
                    <div className='service-item__cercle gradation-red'></div>
                    <p className='service-item__number'>SERVICE02</p>
                    <h3>マーケティング支援</h3>
                    <p className='service-item__detail'>ターゲット市場に最適な戦略で、売上拡大とブランドの認知向上をサポート。<br />SEO対策・SNS運用・広告運用・問い合わせ獲得施策などを通じて、ヨーロッパ市場でのWeb集客を加速させます。</p>
                  </div>
                  <div className='service-item__image'>
                    <img src={imgMarketing} alt="" />
                  </div>
                  <div className='button-content button-arrow button-black'>
                    <a href="/marketing">詳しくみる</a>
                  </div>
                </motion.div>
                <motion.div className="service-box__item" variants={fadeInSlideUp}>
                  <div className='service-item__text'>
                    <div className='service-item__cercle gradation-yellow'></div>
                    <p className='service-item__number'>SERVICE03</p>
                    <h3>ブランディング支援</h3>
                    <p className='service-item__detail'>企業の価値を明確にし、ブランドの世界観を構築。<br />ロゴデザイン・フォント選定・写真・映像制作・越境ローカライズ支援を通じて、国内外で選ばれるブランドへと導きます。</p>
                  </div>
                  <div className='service-item__image'>
                    <img src={imgBranding} alt="" />
                  </div>
                  <div className='button-content button-arrow button-black'>
                    <a href="/branding">詳しくみる</a>
                  </div>
                </motion.div>
              </motion.div>
            </section>
            <section className='reason'>
              <motion.div className="title" variants={fadeInSlideUp} initial={hasAnimated ? "visible" : "hidden"} whileInView="visible" viewport={{ once: true, amount: 0.2 }} onAnimationComplete={handleAnimationComplete}>
                <p className='title-lead'>REASON</p>
                <h2>LOGOTが選ばれる3つの理由</h2>
              </motion.div>
              <div className='reason-box flexBox-imgText'>
                <motion.div className='flexBox-imgText__item reason-box__item' initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }} >
                  <motion.div className='flexBox-imgText__image reason-item__image' variants={fadeInSlideUp} >
                    <img src={imgReason01} alt="" />
                  </motion.div>
                  <motion.div className='flexBox-imgText__text reason-item__text' variants={slideFromRight} >
                    <p className='reason-item__number text-green'>Feature<span>01</span></p>
                    <h3>ブランド価値を最大化するトータルブランディング支援</h3>
                    <p className='reason-item__detail'>ロゴ・フォント・ビジュアルデザインからWebサイト構築、デジタルマーケティングまで、ブランドの世界観を統一し、競争力を高める総合的なブランディング支援を提供。</p>
                  </motion.div>
                </motion.div>
                <motion.div className='flexBox-imgText__item reason-box__item' initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }} >
                  <motion.div className='flexBox-imgText__text reason-item__text' variants={slideFromLeft} >
                    <p className='reason-item__number text-green'>Feature<span>02</span></p>
                    <h3>ヨーロッパ市場で成功するためのグローバル戦略支援</h3>
                    <p className='reason-item__detail'>ロゴ・フォント・ビジュアルデザインからWebサイト構築、デジタルマーケティングまで、ブランドの世界観を統一し、競争力を高める総合的なブランディング支援を提供。</p>
                  </motion.div>
                  <motion.div className='flexBox-imgText__image reason-item__image' variants={fadeInSlideUp} >
                    <img src={imgReason02} alt="" />
                  </motion.div>
                </motion.div>
                <motion.div className='flexBox-imgText__item reason-box__item' initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.3 }} >
                  <motion.div className='flexBox-imgText__image reason-item__image' variants={fadeInSlideUp} >
                    <img src={imgReason03} alt="" />
                  </motion.div>
                  <motion.div className='flexBox-imgText__text reason-item__text' variants={slideFromRight} >
                    <p className='reason-item__number text-green'>Feature<span>03</span></p>
                    <h3>ビジネス成長を加速するワンストップ支援</h3>
                    <p className='reason-item__detail'>市場分析・戦略立案・制作・運用・データ分析まで、一貫したサポート体制でビジネスの成長を加速。<br />継続的な改善を行いながら、企業の目標達成を支援します。</p>
                  </motion.div>
                </motion.div>
              </div>
            </section>
            <CtaNomal></CtaNomal>
            <section className='about'>
              <motion.div className="title" variants={fadeInSlideUp} initial={hasAnimated ? "visible" : "hidden"} whileInView="visible" viewport={{ once: true, amount: 0.2 }} onAnimationComplete={handleAnimationComplete}>
                <p className='title-lead'>About Us</p>
                <h2>海外の未来をおもしろくする</h2>
              </motion.div>
              <div className='about-text'>
                <p>ヨーロッパには、独自の技術や個性を持つ企業が数多く存在し、<br className="pc-only" />地域ごとの文化や歴史、価値あるブランドも豊かに広がっています。<br />しかし、グローバル市場では、こうした企業やブランドが十分に認知されていないことも少なくありません。<br />企業が成長すれば、新たなビジネスチャンスが生まれ、<br className="pc-only" />市場での競争力が高まり、ブランドの価値も向上します。<br />この成長を加速させるために必要なのは、"ブランディング"と"デジタル戦略"です。<br />LOGOTは、ヨーロッパ市場で挑戦する企業のために、<br className="pc-only" />デザイン・デジタル（DX）・マーケティング支援を通じて、ブランドの可能性を最大化。<br />企業の魅力を世界に届け、持続的な成長へと導きます。</p>
              </div>
              <div className='button-content button-arrow button-black'>
                <a href="/company">会社概要をみる</a>
              </div>
            </section>
            <CtaNomal></CtaNomal>
          </div>
        </div >
      </main >
      <Footer></Footer>
    </>
  );
};

export default Top